<template>
    <div>
        <!-- Vehicles of Interest !-->
        <div class="row" style="font-size: 14px;">
            <div class="col-8">
                <hr class="labeled" data-content="Vehicle(s)">
            </div>
            <div class="col text-right">
                <ui-button
                    size="small"
                    icon="add"
                    color="primary"
                    type="secondary"
                    :disabled="disabled"
                    @click="addVehicleOfInterest"
                >Add</ui-button>
            </div>
        </div>
        <div v-for="(vehicleOfInterest, k) in vehiclesOfInterest">
            <vehicle-snippet
                :vehicle="vehiclesOfInterest[k]"
                @remove="removeVehicleOfInterest"
                @click="showVehicle"
                hide-derivative
                :disabled="disabled"
            ></vehicle-snippet>
        </div>
        <div v-if="vehiclesOfInterest.length === 0" style="margin-bottom: 1rem; font-size: 1rem;">
            No vehicles added
        </div>

        <!-- Appraisal !-->
        <div class="row" style="font-size: 14px; margin-top: 1rem;">
            <div class="col-8">
                <hr class="labeled" data-content="Part Exchange(s)">
            </div>
            <div class="col text-right">
                <ui-button
                    size="small"
                    icon="add"
                    color="primary"
                    type="secondary"
                    :disabled="disabled"
                    @click="addAppraisal"
                >Add</ui-button>
            </div>
        </div>

         <div v-for="appraisal in appraisals">
             <appraisal-snippet
                :appraisal="appraisal"
                :disabled="disabled"
                @remove="removeAppraisal(appraisal)"
                @click="showAppraisal(appraisal)"
            ></appraisal-snippet>
        </div>


        <div v-if="appraisals.length === 0" style="margin-bottom: 1rem; font-size: 1rem;">
            No vehicles added
        </div>

        <vehicle-appraisal-modal
            ref="appraisal"
            @identified="existingVehicleCheck"
            @save="finishAddingAppraisal"
        ></vehicle-appraisal-modal>

        <vehicle-search-modal
            ref="search"
            @selected="finishAddingVehicleOfInterest"
        ></vehicle-search-modal>
    </div>
</template>

<script>

import AddVehicleForm from "./vehicles/AddVehicleForm";
import {LeadDetailSchema, LeadDetailTypes} from "../../classes/Api/Lead";
import VehicleSnippet from "../lead/VehicleSnippet.vue";
import VehicleSearchModal from "../lead/VehicleSearchModal.vue";
import VehicleAppraisalModal from "../VehicleAppraisalModal.vue";
import LeadPaneHelpers from "../lead/LeadPaneHelpers";
import {openInNewTab} from "../../utils";
import AppraisalSnippet from "../lead/AppraisalSnippet.vue";

export default {
    components: {AppraisalSnippet, VehicleAppraisalModal, VehicleSearchModal, VehicleSnippet, AddVehicleForm},
    mixins: [LeadPaneHelpers],
    props: {
        leadId: {
            type: Number,
        },
        value: {
            type: Object,
        },
        hideDerivative: {
            type: Boolean,
            default: false
        },
        isBusy: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            vehiclesOfInterest: [],
        }
    },

    methods: {
        addVehicleOfInterest() {
            this.$refs.search.open()
        },
        finishAddingVehicleOfInterest(vehicle) {
            if (this.vehiclesOfInterest.find((existingVehicleOfInterest) => {
                return vehicle.id === existingVehicleOfInterest.id
            })) {
                alert('This vehicle is already attached to the lead')
                return
            }

            this.vehiclesOfInterest.push(vehicle)

            this.$emit('added', {
                type: LeadDetailTypes.VEHICLE_OF_INTEREST,
                vehicle
            })
        },
        removeVehicleOfInterest(vehicle) {
            if (confirm('Are you sure you want to remove the vehicle?')) {
                this.$emit('removed', {
                    type: LeadDetailTypes.VEHICLE_OF_INTEREST,
                    vehicle
                })
            }
        },
        triggerInput() {
            this.$emit('input', [this.vehiclesOfInterest, this.appraisals])
        },
    },
    computed: {
        detail() {
            let result = []

            for (let i in this.vehiclesOfInterest) {
                result.push(new LeadDetailSchema({
                    lead_id: this.lead_id,
                    detail: this.vehiclesOfInterest[i].detail,
                    detail_id: this.vehiclesOfInterest[i].detail.id,
                    detail_type: 'vehicle.instance',
                    type: LeadDetailTypes.VEHICLE_OF_INTEREST,
                }))
            }

            for (let i in this.appraisals) {
                result.push(new LeadDetailSchema({
                    lead_id: this.lead_id,
                    detail: this.appraisals[i].detail,
                    detail_id: this.appraisals[i].detail.id,
                    detail_type: 'vehicle.instance',
                    type: LeadDetailTypes.VEHICLE_OFFERED,
                }))
            }

            return result
        }
    }
}
</script>

<style scoped>
    .vehicle-snippet { margin-bottom: 15px; cursor: pointer; }
</style>